module.exports = __webpack_public_path__ + "static/img/remark-data.0b1e876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/remark-data.png
// module id = eANS
// module chunks = 1